import { render, staticRenderFns } from "./UserFormPageBreak.vue?vue&type=template&id=03b83f95&scoped=true&"
import script from "./UserFormPageBreak.vue?vue&type=script&lang=js&"
export * from "./UserFormPageBreak.vue?vue&type=script&lang=js&"
import style0 from "./UserFormPageBreak.vue?vue&type=style&index=0&id=03b83f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b83f95",
  null
  
)

export default component.exports